export default "__VITE_ASSET__84daedb7__"